<template>
  <section>
    <home-info-row
      src="img/home/img1.png"
      :alt="$t('home.img.alt.girl')"
      :headline="$t('home.row-info-1.headline')"
      :firstCategoryParagraphs="row1.firstCategoryParagraphs"
      :secondCategoryParagraphs="row1.secondCategoryParagraphs"
      :containerClass="$style.row1"
    />
    <home-info-row
      src="img/home/img2.png"
      :alt="$t('home.img.alt.man')"
      :headline="$t('home.row-info-2.headline')"
      :firstCategoryParagraphs="row2.firstCategoryParagraphs"
      :secondCategoryParagraphs="row2.secondCategoryParagraphs"
      :containerClass="$style.row2"
      class="row-reverse"
    />
  </section>
</template>

<script>
import HomeInfoRow from '@/components/home/HomeInfoRow.vue';

export default {
  components: {
    HomeInfoRow,
  },
  data() {
    return {
      row1: {
        firstCategoryParagraphs: [
          this.$t('home.row-info-1.paragraph-1.1'),
          this.$t('home.row-info-1.paragraph-1.2'),
        ],
        secondCategoryParagraphs: [
          this.$t('home.row-info-1.paragraph-2.1'),
          this.$t('home.row-info-1.paragraph-2.2'),
        ],
      },
      row2: {
        firstCategoryParagraphs: [
          this.$t('home.row-info-2.paragraph-1.1'),
          this.$t('home.row-info-2.paragraph-1.2'),
        ],
        secondCategoryParagraphs: [
          this.$t('home.row-info-2.paragraph-2.1'),
          this.$t('home.row-info-2.paragraph-2.2'),
          this.$t('home.row-info-2.paragraph-2.3'),
        ],
      },
    };
  },
};
</script>

<style lang="scss" module>
@import '~@/assets/styles/variables';
@import '~@/assets/styles/breakpoints';

.row1 {
  padding-top: $home-container-vertical-padding;
  padding-left: $home-container-horizontal-padding;
}
.row2 {
  padding-right: $home-container-horizontal-padding;
}

@media (max-width: $page-table-breakpoint) {
  .row1 {
    padding-top: 0;
    padding-left: 0;
  }
  .row2 {
    padding-right: 0;
  }
}
</style>
